import React, { Component } from 'react'
import { Oval } from 'react-loader-spinner'
import classnames from 'classnames'
import './index.scss'
import { config } from '../../../helpers';

function getSpinnerImgSrc() {
    if (config.commbank) return '/images/icons/cb-loading.svg';
    if (config.rmworks) return '/images/icons/rmw-loading.svg';
    if (config.mediumrare) return '/images/icons/mr-loading.svg';    
    return '/images/icons/loading.svg';
}
export default class Spinner extends Component {

    render() {
        const { className, color, height = 100, width = 100, type = "b" } = this.props;

        return (
            type === "oval" ?
                <Oval
                    height={height}
                    width={width}
                    color={color ? color : "#EC1555"}
                    wrapperClass={classnames(className, "d-flex align-self-center justify-content-center p-0")}
                    secondaryColor="white"
                />
                :
                <div className={classnames("d-flex align-self-center justify-content-center bb-spinner-container", config.rmworks ? "rmw" :config.commbank ? "cb" : config.mediumrare ? "mr" :"")}
                    style={{ height: height + 'px', width: width + 'px' }}
                >
                    <span>
                        <img src={getSpinnerImgSrc()} 
                            style={{ height: height + 'px', width: width + 'px' }} alt="" />
                    </span>
                </div>
        );
    }
}

